// Single source of truth for all review-flow trigger values and their display names.
// No raw trigger strings should appear anywhere else in the frontend.

export const REVIEW_TRIGGERS = Object.freeze({
  FORECAST_REPORT_VIEWED: "FORECAST_REPORT_VIEWED",
  PO_CREATED: "PO_CREATED",
  BEST_SELLERS_VIEWED: "BEST_SELLERS_VIEWED",
  SYNC_COMPLETED: "SYNC_COMPLETED",
  EXPORT_COMPLETED: "EXPORT_COMPLETED",
});

export const TRIGGER_FEATURE_NAMES = {
  [REVIEW_TRIGGERS.FORECAST_REPORT_VIEWED]: "Forecast Report",
  [REVIEW_TRIGGERS.PO_CREATED]: "Purchase Order Creation",
  [REVIEW_TRIGGERS.BEST_SELLERS_VIEWED]: "Best Sellers Report",
  [REVIEW_TRIGGERS.SYNC_COMPLETED]: "Inventory Sync",
  [REVIEW_TRIGGERS.EXPORT_COMPLETED]: "Forecast Report Export",
};

// Triggers that must NOT fire within the first 24h after installation
export const DAY_GATED_TRIGGERS = new Set([
  REVIEW_TRIGGERS.PO_CREATED,
  REVIEW_TRIGGERS.BEST_SELLERS_VIEWED,
  REVIEW_TRIGGERS.SYNC_COMPLETED,
  REVIEW_TRIGGERS.EXPORT_COMPLETED,
]);

// Delays (in milliseconds) before firing each trigger after the value moment occurs.
// Used by the page-level timers; the decision hook itself does not apply delays.
export const TRIGGER_DELAYS_MS = {
  [REVIEW_TRIGGERS.FORECAST_REPORT_VIEWED]: 180000, // 180s
  [REVIEW_TRIGGERS.PO_CREATED]: 120000,             // 120s after the "Create PO" explainer popup is closed
  [REVIEW_TRIGGERS.BEST_SELLERS_VIEWED]: 60000,     // 60s
  [REVIEW_TRIGGERS.SYNC_COMPLETED]: 60000,          // 60s
  [REVIEW_TRIGGERS.EXPORT_COMPLETED]: 0,            // immediate (combined card)
};
